module.exports = __webpack_public_path__ + "static/salon-pasajeros---acabado-techo-9704c91eee490988f059da7f2b36a88b.jpg";